// extracted by mini-css-extract-plugin
export default {"popupContent":"ConfirmationPopup_popupContent__dnub3","buttonGroup":"ConfirmationPopup_buttonGroup__PVTOl"};